import { ChevronsLeft } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  useSidebar,
} from "@/components/ui/sidebar";
import { Button } from "@/components/ui/button";
import SuiteSwitcher from "../SuiteSwitcher";
import { useSidebarSections } from "../useSidebarSections";

import Collapsed from "./Collapsed";
import PinnedNavItem from "./PinnedNavItem";
import SideBarAccordan from "./SidebarAccordan/SideBarAccordan";
import AppSidebarDashBoard from "./AppSidebarDashBoard";
import { useHrNav } from "@/features/hr/hooks/useHrNav";

export function AppSidebar() {
  const { toggleSidebar, state, locked } = useSidebar();
  const isCollapsed = state === "collapsed";
  const { isHrActive } = useHrNav();
  // Which suite's groups these are is decided in the hook — both suites render
  // through the same accordion below, so HR cannot drift from the CRM's look.
  const { sections, settings } = useSidebarSections();

  return (
    <Sidebar collapsible="icon">
      <SidebarHeader>
        {/* The workspace block doubles as the suite switcher — see SuiteSwitcher.
            It falls back to rendering SidebarHeaderContent bare for single-suite
            users, so this stays correct for tenants without HR. */}
        <SuiteSwitcher />
      </SidebarHeader>
      <Separator />

      <SidebarContent>
        {/* Dashboard / Whatsapp / Gmail are CRM surfaces, not shell-global —
            one suite at a time means they stay out of HR. */}
        {!isHrActive && <AppSidebarDashBoard isCollapsed={isCollapsed} />}

        {isCollapsed ? (
          <Collapsed sections={sections} />
        ) : (
          <SideBarAccordan sections={sections} />
        )}
      </SidebarContent>

      {/* Nothing pinned (every user without HR) → the bare footer the CRM
          always rendered, so its sidebar stays pixel-identical. */}
      <SidebarFooter className={settings ? "pb-3" : undefined}>
        {settings && (
          <PinnedNavItem route={settings} isCollapsed={isCollapsed} />
        )}
      </SidebarFooter>

      {/* Pinned screens (custom reports) have NO expand control — the rail and
          its links stay, the chevron goes. */}
      {locked ? null : (
        <Button
          variant="drawer"
          onClick={toggleSidebar}
          aria-label="Toggle Sidebar"
        >
          <ChevronsLeft
            className={`h-4 w-4 transition-transform duration-200 ${
              isCollapsed ? "rotate-180" : ""
            }`}
          />
        </Button>
      )}
    </Sidebar>
  );
}
